import React, { Component } from "react";
import { loading, profile, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { cartRead, cartSetQty, cartRemove, cartClear, priceOf } from "../components/cart.js";

import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = { items: cartRead(), select_payment: "", sending: false };
  }
  componentDidMount() {
    loading(false);
  }
  refresh = () => this.setState({ items: cartRead() });

  // เกม = fee ของช่องทางที่เลือก, มือถือ = fee ของ payment ที่ชื่อตรงกับชื่อมือถือ (เหมือน payment_mobile.js)
  feeRate = (item) => {
    if (item.type === "mobile") return global.payment.find((e) => e.name === item.gameName)?.fee || 0;
    return global.payment[this.state.select_payment]?.fee || 0;
  };
  lineOf = (item) => {
    const sub = priceOf(item.package) * item.qty;
    const fee = sub * this.feeRate(item);
    return { sub, fee, total: sub + fee };
  };

  Payment = async () => {
    const { items, select_payment } = this.state;
    if (!profile) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเข้าสู่ระบบก่อนทำรายการ");
      return;
    }
    if (items.length === 0) {
      alert("", "warning", "แจ้งเตือน", "ตะกร้าว่างเปล่า");
      return;
    }
    if (items.some((e) => e.type === "game") && select_payment === "") {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกการชำระเงิน");
      return;
    }
    this.setState({ sending: true });
    try {
      const lines = items.map((item) => {
        const l = this.lineOf(item);
        return {
          type: item.type,
          source: item.source,
          game: item.gameName,
          id_game: item.id_game,
          package: item.package,
          qty: item.qty,
          payment: item.type === "mobile" ? item.gameName : global.payment[select_payment]?.name,
          fee: this.feeRate(item),
          fee_amount: l.fee,
          price: l.total,
        };
      });
      const res = await fetch(
        `${"https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"}payment_cart/${new Date().getTime()}.json`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: lines,
            payment: global.payment[select_payment]?.name || null,
            total: lines.reduce((s, e) => s + e.price, 0),
          }),
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      cartClear();
      await alert("login", "success", "สำเร็จ", "QR code การชำระเงิน ถูกส่งไปทางอีเมลที่ท่านได้ลงทะเบียนไว้ กรุณาชำระเงินภายใน 30 นาที");
      window.location.href = "/";
    } catch (e) {
      this.setState({ sending: false });
      alert("", "warning", "แจ้งเตือน", `ทำรายการไม่สำเร็จ: ${e?.message || e}`);
    }
  };

  render() {
    const { items, select_payment, sending } = this.state;
    const hasGame = items.some((e) => e.type === "game");
    const sums = items.reduce(
      (s, e) => {
        const l = this.lineOf(e);
        return { sub: s.sub + l.sub, fee: s.fee + l.fee, total: s.total + l.total };
      },
      { sub: 0, fee: 0, total: 0 }
    );
    return (
      <div className="game-page w-100 min-vh-100 position-relative overflow-hidden">
        <div className="game-page__ambient game-page__ambient--one"></div>
        <div className="game-page__ambient game-page__ambient--two"></div>
        <div className="game-page__grid"></div>

        <Navbar />
        <div className="container mx-auto my-5">
          <h2 className="fw-bold text-white mb-4" style={{ paddingTop: 70 }}>ตะกร้าสินค้า</h2>
          {items.length === 0 ? (
            <div className="p-4 bg-white rounded-4 text-center" data-testid="cart-empty">
              <p className="mb-3">ตะกร้าว่างเปล่า</p>
              <a className="btn btn-primary" href="/game-uid">เลือกสินค้า</a>
            </div>
          ) : (
            <div className="row">
              <div className="col-12 col-lg-8">
                {items.map((item) => {
                  const l = this.lineOf(item);
                  return (
                    <div key={item.id} className="bg-white rounded-4 p-3 mb-3 cart-item" data-testid="cart-item">
                      <div className="d-flex flex-wrap justify-content-between align-items-start">
                        <div className="me-3" style={{ minWidth: 0, flex: "1 1 200px" }}>
                          <h6 className="fw-bold mb-1">{item.gameName}</h6>
                          <div>{item.package?.name}</div>
                          {item.type === "game" && <small className="text-secondary">ID game: {item.id_game}</small>}
                        </div>
                        <div className="text-end fw-bold text-info">฿ {l.sub.toFixed(2)}</div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="d-flex align-items-center">
                          <button className="btn btn-outline-secondary btn-sm" aria-label="ลดจำนวน" disabled={item.qty <= 1} onClick={() => { cartSetQty(item.id, item.qty - 1); this.refresh(); }}>-</button>
                          <span className="mx-3" data-testid="cart-qty">{item.qty}</span>
                          <button className="btn btn-outline-secondary btn-sm" aria-label="เพิ่มจำนวน" disabled={item.qty >= 99} onClick={() => { cartSetQty(item.id, item.qty + 1); this.refresh(); }}>+</button>
                        </div>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => { cartRemove(item.id); this.refresh(); }}>ลบ</button>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="col-12 col-lg-4">
                <div className="p-3 mx-auto bg-white rounded-4">
                  {hasGame && (
                    <>
                      <h5 className="fw-bold mb-3">ช่องทางการชำระเงิน</h5>
                      <div className="row mb-3">
                        {global.payment.map((item, index) => (
                          <div key={index} className="col-12 col-xl-6 mb-2 px-1">
                            <div
                              className={`mx-auto ${select_payment === index ? "bg-primary-light border-1 border-info" : "bg-white border-1 border-secondary"} rounded-4 overflow-hidden pointer product`}
                              onClick={() => this.setState({ select_payment: index })}
                            >
                              <div className="w-100 p-1 d-flex align-items-center">
                                <img src={item?.image} alt="" className="wpx-40 hpx-40 me-3 rounded-4" />
                                <h6 className="fw-bold w-100 overflow-hidden mb-0 text-nowrap" style={{ textOverflow: "ellipsis" }}>{item.name || ""}</h6>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-between">
                    <span>ราคาสินค้า</span>
                    <span data-testid="cart-sub">{sums.sub.toFixed(2)}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between">
                    <span>ค่าบริการ</span>
                    <span data-testid="cart-fee">{sums.fee.toFixed(2)}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between mb-3">
                    <span>จำนวนเงินที่ชำระ</span>
                    <span className="fw-bold" data-testid="cart-total">{sums.total.toFixed(2)}</span>
                  </div>
                  <button className="btn btn-primary w-100" disabled={sending} onClick={this.Payment}>ชำระเงิน</button>
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
